import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Breadcrumbs,
  Link,
  Typography,
  Box
} from '@mui/material';
import {
  Home as HomeIcon,
  AccountTree as AccountTreeIcon
} from '@mui/icons-material';

const BreadcrumbNavigation = ({ 
  runId, 
  hierarchyId, 
  nodeId, 
  nodeData,
  hierarchyData,
  forecastStartDate 
}) => {
  const navigate = useNavigate();

  // Extract names from data
  const hierarchyName = hierarchyData?.hierarchy_name || nodeData?.hierarchy_name || `Hierarchy ${hierarchyId}`;
  const nodeName = nodeData?.node_name || nodeData?.node_key || `Node ${nodeId}`;
  
  // Extract parent node info from node path
  const nodePath = nodeData?.node_path || '';
  const pathParts = nodePath.split('/').filter(part => part.trim());
  const parentNodeName = pathParts.length > 1 ? pathParts[pathParts.length - 2] : null;

  const handleHomeClick = () => {
    navigate('/forecast-runs');
  };

  const handleHierarchyClick = () => {
    navigate(`/forecast-hierarchy/${runId}`);
  };

  return (
    <Breadcrumbs sx={{ mb: 3 }}>
      {/* Forecast Runs */}
      <Link 
        underline="hover"
        color="inherit"
        onClick={handleHomeClick}
        sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
      >
        <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
        Forecast Runs
      </Link>
      
      {/* Forecast ID */}
      <Link
        underline="hover"
        color="inherit"
        onClick={handleHomeClick}
        sx={{ cursor: 'pointer' }}
      >
        {runId}
      </Link>
      
      {/* Hierarchy */}
      <Link 
        underline="hover"
        color="inherit"
        onClick={handleHierarchyClick}
        sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
      >
        <AccountTreeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
        {hierarchyName}
      </Link>
      
      {/* Parent Node (if exists) */}
      {parentNodeName && (
        <Link
          underline="hover"
          color="inherit"
          onClick={() => {
            // Navigate to parent node if we have its ID
            const parentNodeId = nodeData?.parent_node_id;
            if (parentNodeId) {
              const queryParams = forecastStartDate ? `?forecastStartDate=${forecastStartDate.toISOString().split('T')[0]}` : '';
              navigate(`/forecast-hierarchy/${runId}/hierarchy/${hierarchyId}/node/${parentNodeId}${queryParams}`);
            } else {
              handleHierarchyClick();
            }
          }}
          sx={{ cursor: 'pointer' }}
        >
          {parentNodeName}
        </Link>
      )}
      
      {/* Current Node */}
      <Typography color="text.primary">
        {nodeName}
      </Typography>
    </Breadcrumbs>
  );
};

export default BreadcrumbNavigation; 